import {
    createContext,
    Dispatch,
    MutableRefObject,
    SetStateAction,
} from "react";

type CollectonResullts = {
    [meter: string]: {
        success: boolean;
        message: string;
    };
};

type PaymentMethod = null | {
    id: string;
    name: string;
};

interface ICollectBillsCtx {
    collectionsRef: MutableRefObject<{
        [key: number]: RawCollection;
    }>;

    amountInputsRef: MutableRefObject<{
        [rowIndex: number]: HTMLInputElement;
    }>;

    adjustmentInputsRef: MutableRefObject<{
        [rowIndex: number]: HTMLInputElement;
    }>;

    advanceInputsRef: MutableRefObject<{
        [rowIndex: number]: HTMLInputElement;
    }>;

    collectionResults: CollectonResullts;
    setCollectionResults: Dispatch<SetStateAction<CollectonResullts>>;

    defaultPaymentMethod: PaymentMethod;
    // setDefaultPaymentMethod: Dispatch<SetStateAction<PaymentMethod>>;

    columnsVisibility: {
        [column: string]: boolean;
    };

    collectionDate: string;
    paymentMethodsRes: any[];
    checkAll: boolean;
}

export const CollectBillsCtx = createContext({} as ICollectBillsCtx);
